export const ActionTypes = {
    SET_USER_INFO: "SET_USER_INFO",
    SET_USER_PROFILE:"SET_USER_PROFILE",
    SET_USER_GITHUB_INFO: "SET_USER_GITHUB_INFO",
    SET_USER_PROJECTS: "SET_USER_PROJECTS",
    SET_POST: "SET_POSTS",
    SET_POST_BY_ID: "SET_POSTS_BY_ID",
    SET_JOBS: 'SET_JOBS',
    SET_JOBS_BY_ID: 'SET_JOBS_BY_ID',
    SET_JOBS_BY_USERID: 'SET_JOBS_BY_USERID',
}